import { render, staticRenderFns } from "./WebstarsSearch.vue?vue&type=template&id=3dc629dc&scoped=true&"
import script from "./WebstarsSearch.vue?vue&type=script&lang=js&"
export * from "./WebstarsSearch.vue?vue&type=script&lang=js&"
import style0 from "./WebstarsSearch.vue?vue&type=style&index=0&id=3dc629dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc629dc",
  null
  
)

export default component.exports